module.exports = __webpack_public_path__ + "img/cabinet.2c726cf1.png";